import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ProjectIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4ZM5.0303 4.66667H6.96967C7.17053 4.66667 7.33333 4.82947 7.33333 5.0303V6.96967C7.33333 7.17053 7.17053 7.33333 6.96967 7.33333H5.0303C4.82947 7.33333 4.66667 7.17053 4.66667 6.96967V5.0303C4.66667 4.82947 4.82947 4.66667 5.0303 4.66667ZM9.03033 4.66667H10.9697C11.1705 4.66667 11.3333 4.82947 11.3333 5.0303V6.96967C11.3333 7.17053 11.1705 7.33333 10.9697 7.33333H9.03033C8.82947 7.33333 8.66667 7.17053 8.66667 6.96967V5.0303C8.66667 4.82947 8.82947 4.66667 9.03033 4.66667ZM6.96967 8.66667H5.0303C4.82947 8.66667 4.66667 8.82947 4.66667 9.03033V10.9697C4.66667 11.1705 4.82947 11.3333 5.0303 11.3333H6.96967C7.17053 11.3333 7.33333 11.1705 7.33333 10.9697V9.03033C7.33333 8.82947 7.17053 8.66667 6.96967 8.66667ZM9.03033 8.66667H10.9697C11.1705 8.66667 11.3333 8.82947 11.3333 9.03033V10.9697C11.3333 11.1705 11.1705 11.3333 10.9697 11.3333H9.03033C8.82947 11.3333 8.66667 11.1705 8.66667 10.9697V9.03033C8.66667 8.82947 8.82947 8.66667 9.03033 8.66667Z"
		/>
	</svg>
))
